<div class="d-flex flex-column h-100 position-relative">

  <!-- Chat: Content -->
  <div #scrollMe (scroll)="scrollMessageContainer()"
       class="chat-body hide-scrollbar flex-1 h-100 d-flex flex-column"
       id="scrollMe">
    <app-progress-bar
      *ngIf="billingInfo.hasSubscription && chosenTicket.status !== 'closed' && !chosenTicket.need_confirm_close_unsolved_ticket && !chosenTicket.need_confirm_close_ticket && (chosenTicket.ticket_time_status !== 'hide')"
      [ticketStatus]="chosenTicket.ticket_time_status"
      [timeToLock]="chosenTicket.estimate_time.time_to_lock"
      [timeToSolve]="chosenTicket.estimate_time.time_to_solve"
      [ticketId]="chosenTicket.id"
    ></app-progress-bar>

    <div class="chat-body-inner flex-grow-1">
      <div class="py-6 py-lg-12 px-5">
        <div class="d-flex justify-content-center position-relative">
          <ngx-spinner [fullScreen]="false"
                       bdColor="#00000000"
                       color="#000000"
                       name="loadMoreSpinner"
                       size="default"
                       type="ball-running-dots"
          ></ngx-spinner>
        </div>

        <div *ngIf="elementShow.showMoreBtnShow" class="d-flex justify-content-center more-btn-container mb-5">
          <button (click)="loadHistoryNextPage()" class="btn btn-sm rounded-pill app-btn-gray btn-outline">
            load more...
          </button>
        </div>

        <app-message #item
                     (replied)="onReply(message)"
                     *ngFor="let message of messages; index as i; trackBy: trackByFn"
                     [index]="i"
                     [message]="message"
                     [messages]="messages"
        ></app-message>

        <app-mark-solved-message
          (questionAsked)="askQuestionClick()"
          (markedAsDone)="markAsDone()"
          *ngIf="elementShow.markSolvedMessageShow"
        ></app-mark-solved-message>

        <!-- Message -->
        <div *ngIf="isExpertTyping" class="message">
          <a class="avatar avatar-responsive" data-bs-target="#modal-user-profile" data-bs-toggle="modal"
             href="#">
            <img [src]="currentExpert.img" alt="" class="avatar-img">
          </a>

          <div class="message-inner">
            <div class="message-body">
              <div class="message-content">
                <div class="message-text">
                  <p>{{currentExpert.name}}<span
                    class="typing-dots"><span>.</span><span>.</span><span>.</span></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <app-subscribe-message
      *ngIf="!billingInfo.hasSubscription && !billingInfo.balance && chosenTicket.status === 'closed' && !billingInfo.isUserFree"
      [class.mb-0]="!(chosenTicket.status === 'closed' && billingInfo.hasSubscription && billingInfo.balance)"
      class="position-sticky service-message service-message_priority"
    ></app-subscribe-message>


    <app-balance-message
      *ngIf="!billingInfo.balance && billingInfo.hasSubscription && chosenTicket.status === 'closed' && !billingInfo.isUserFree"
      [class.mb-0]="!(chosenTicket.status === 'closed' && billingInfo.hasSubscription && billingInfo.balance)"
      class="position-sticky service-message"
    ></app-balance-message>

    <app-new-task-message
      *ngIf="billingInfo.hasSubscription && billingInfo.balance && chosenTicket.status === 'closed'"
      class="position-sticky service-message d-block d-md-none mb-0"
      (newTaskCreated)="createNewTask()"
    ></app-new-task-message>
  </div>
  <!-- Chat: Content -->
  <!-- Chat: Footer -->
  <div
    *ngIf="elementShow.chatFooterShow"
    class="chat-footer py-3 px-5 py-md-7 px-md-10 bottom-0 start-0  border-outline border-top border-2 bg-white position-relative"
  >

    <button (click)="scrollToBottom()"
            *ngIf="elementShow.scrollBottomBtn.show"
            [ngClass]="elementShow.scrollBottomBtn.msgIndicatorShow ? 'btn-scroll__new-message' : ''"
            class="btn btn-outline app-btn-black d-flex btn-scroll position-absolute p-3">
          <span class="icon icon-lg">
            <svg class="feather feather-arrow-down" fill="none" height="24" stroke="currentColor" stroke-linecap="round"
                 stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                 xmlns="http://www.w3.org/2000/svg">
              <line x1="12" x2="12" y1="5" y2="19"></line>
              <polyline points="19 12 12 19 5 12"></polyline>
            </svg>
          </span>
    </button>

    <div *ngIf="repliedMessage" class="chat-reply mb-4">
      <div class="d-flex align-items-center">
        <button (click)="repliedMessage = null"
                class="d-none d-md-block btn-close mx-6 align-self-start text-primblack">
        </button>

        <div class="border rounded border-dark d-flex p-5 w-100">

          <button (click)="repliedMessage = null"
                  class="d-md-none btn-close align-self-start text-primblack">
          </button>

          <!--  REPLY IMG-->
          <div *ngIf="repliedMessage.file && repliedMessage.file?.name">
            <div *ngIf="repliedMessage.file.is_image === 'true'"
                 class="avatar avatar-xl overflow-hidden rounded-3">
              <img [src]="repliedMessage.file.url" alt="" class="reply-img">
            </div>
          </div>
          <!--  REPLY IMG END-->

          <div
            *ngIf="repliedMessage.file && repliedMessage.file?.name"
            class="border rounded-1 border-black align-self-stretch ms-3"
          ></div>

          <!--  REPLY AUTHOR-->
          <div class="reply-author d-flex flex-column my-auto ms-4 text-primblack pe-3 pe-md-8">
            <p class="reply-name m-0 fs-6 fw-bold">
              {{repliedMessage.author.name}}
            </p>
            <p class="reply-date m-0 small">
              <small>
                {{(repliedMessage.created_at * 1000) | date:'dd.MM.yyyy HH:mm'}}
              </small>
            </p>
          </div>
          <!--  REPLY AUTHOR END-->

          <div
            *ngIf="!(repliedMessage.file && repliedMessage.file?.name)"
            class="border rounded-1 border-black align-self-stretch me-3"
          ></div>

          <!--  REPLY CONTENT-->
          <div class="flex-grow-1 d-flex align-items-center">
            <!--  REPLY TEXT-->
            <p *ngIf="repliedMessage.type === 'text' || repliedMessage.type === 'web_support_message'"
               class="flex-grow-1 my-auto small text-primblack">
              {{repliedMessage.body | slice:0:70}}{{repliedMessage.body.length > 70 ? '...' : ''}}
            </p>
            <!--  REPLY TEXT END-->

            <!--  REPLY FORMULA-->
            <div *ngIf="isFormula(repliedMessage)" class="flex-grow-1">
              <div
                [innerHTML]="'$' + repliedMessage.body + '$'"
                class="d-flex formula p-4 rounded justify-content-start bg-dark text-primblack"
              ></div>
            </div>
            <!--  REPLY FORMULA END-->

            <!--  REPLY AUTOSOLUTION-->
            <div *ngIf="repliedMessage.type === 'autosolution'"
                 class="flex-grow-1 reply-autosolution d-flex flex-column align-items-start">
              <p
                *ngIf="repliedMessage.data[0]?.substeps[0][0].name.trim()"
                [innerHTML]="repliedMessage.data[0]?.substeps[0][0].name"
                class="fs-6 text-primblack"></p>
              <div
                *ngIf="repliedMessage.data[0]?.substeps[0][0].expression.replaceAll('$', '').trim().length"
                [innerHTML]="repliedMessage.data[0]?.substeps[0][0].expression"
                class="d-flex formula p-4 rounded justify-content-start bg-dark text-primblack"
              >
              </div>
              <p
                *ngIf="repliedMessage.data[0]?.substeps[0].length > 1"
                class="text-primblack"
              >
                ...
              </p>
            </div>
            <!--  REPLY AUTOSOLUTION END-->
          </div>
          <!--  REPLY CONTENT END-->
        </div>
      </div>
    </div>

    <!-- Chat: Form -->
    <form>
      <div class="d-flex justify-content-center align-items-center">
        <label
          class="btn app-btn-gray p-3 d-flex me-md-5"
          for="shareFile">
                <span class="icon icon-xl">
                  <svg fill="currentColor" height="24" viewBox="0 0 24 24" width="24"
                       xmlns="http://www.w3.org/2000/svg">
                    <path clip-rule="evenodd"
                          d="M2.05714 5.14286C2.05714 3.43866 3.43866 2.05714 5.14286 2.05714H18.8571C20.5613 2.05714 21.9429 3.43866 21.9429 5.14286V13.6317L20.9555 12.6443L20.9413 12.6304C20.1654 11.8838 19.2112 11.4243 18.171 11.4243C17.1308 11.4243 16.1766 11.8838 15.4007 12.6304L15.3866 12.6443L14.7428 13.2881L11.3559 9.90119L11.3418 9.88734C10.5658 9.14068 9.61167 8.68125 8.57143 8.68125C7.53119 8.68125 6.57705 9.14068 5.8011 9.88734L5.78698 9.90119L2.05714 13.631V5.14286ZM14.0371 15.4916L16.7584 18.213C17.1601 18.6146 17.8113 18.6146 18.213 18.213C18.6147 17.8113 18.6147 17.16 18.213 16.7583L16.1974 14.7427L16.8337 14.1064C17.3063 13.6541 17.7687 13.4815 18.171 13.4815C18.5733 13.4815 19.0357 13.6541 19.5083 14.1063L21.9429 16.5409V18.8571C21.9429 20.5613 20.5613 21.9429 18.8571 21.9429H5.14286C3.43866 21.9429 2.05714 20.5613 2.05714 18.8571V16.5403L7.23413 11.3633C7.70677 10.911 8.16914 10.7384 8.57143 10.7384C8.97372 10.7384 9.43609 10.911 9.90873 11.3633L13.9938 15.4484C14.0008 15.4558 14.0079 15.4631 14.0151 15.4703C14.0224 15.4775 14.0297 15.4846 14.0371 15.4916ZM0 18.8571V16.1143V16.1141V5.14286C0 2.30254 2.30254 0 5.14286 0H18.8571C21.6975 0 24 2.30254 24 5.14286V18.8571C24 21.6975 21.6975 24 18.8571 24H5.14286C2.30254 24 0 21.6975 0 18.8571ZM16.1143 5.51429C15.562 5.51429 15.1143 5.962 15.1143 6.51429C15.1143 7.06657 15.562 7.51429 16.1143 7.51429H16.1276C16.6799 7.51429 17.1276 7.06657 17.1276 6.51429C17.1276 5.962 16.6799 5.51429 16.1276 5.51429H16.1143Z"
                          fill-rule="evenodd"/>
                  </svg>
                </span>
        </label>
        <textarea (keydown.enter)="sendTextMessage($event)"
                  [formControl]="messageControl"
                  class="form-control w-100 me-md-5 fs-6"
                  data-autosize="true"
                  data-emoji-input=""
                  id="messageInput" maxlength="500" placeholder="Type your message..." rows="1"
                  style="overflow: hidden; overflow-wrap: break-word; resize: none; height: 46px;"
        ></textarea>
        <a (click)="billingBtnClick($event)" class="btn app-btn-gray p-3 d-flex me-md-5" href="#">
                  <span class="icon icon-xl">
                    <svg fill="currentColor" height="24" viewBox="0 0 24 24" width="24"
                         xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M19.4019 10.4318C19.2476 10.0544 19.0405 9.70091 18.7869 9.38175C19.3947 8.6374 19.7356 7.71081 19.755 6.75C19.755 3.3852 15.5781 0.75 10.245 0.75C4.92 0.75 0.75 3.3852 0.75 6.75C0.764586 7.7077 1.09594 8.6336 1.6923 9.3831C1.09715 10.127 0.765727 11.0474 0.75 12C0.766029 12.9561 1.09994 13.8797 1.69905 14.625C1.09994 15.3703 0.766029 16.2939 0.75 17.25C0.75 20.6148 4.92 23.25 10.245 23.25C11.5102 23.2446 12.7695 23.0783 13.9927 22.755C15.6163 23.4114 17.4317 23.4093 19.0538 22.7492C20.6758 22.0891 21.9768 20.8229 22.6806 19.2193C23.3845 17.6158 23.4357 15.801 22.8235 14.1603C22.2114 12.5196 20.9839 11.1819 19.4017 10.4313L19.4019 10.4318ZM10.245 2.25C14.5867 2.25 18.255 4.311 18.255 6.75C18.2215 7.55284 17.8708 8.30958 17.28 8.8542C16.9234 9.217 16.5214 9.53221 16.0841 9.792C14.8153 9.86537 13.5937 10.2988 12.5623 11.0415C11.7982 11.1841 11.0223 11.2539 10.245 11.25C5.9112 11.25 2.25 9.189 2.25 6.75C2.25 4.311 5.91135 2.25 10.245 2.25ZM9.7518 16.4806C7.35242 16.511 5.02448 15.6645 3.20505 14.1C2.62089 13.5543 2.27736 12.7989 2.25 12C2.26041 11.4506 2.43448 10.9168 2.74995 10.4669C4.92453 12.0409 7.56216 12.8444 10.245 12.75C10.4746 12.75 10.6882 12.73 10.9107 12.72C10.1572 13.8295 9.75362 15.1395 9.75195 16.4806H9.7518ZM10.245 21.75C5.9112 21.75 2.25 19.689 2.25 17.25C2.26039 16.6965 2.43664 16.1588 2.75595 15.7065C4.83844 17.2192 7.35361 18.0191 9.9273 17.9874C10.2546 19.4036 11.0321 20.6756 12.1434 21.6126C11.5146 21.7027 10.8802 21.7486 10.245 21.75V21.75ZM16.5 21.75C15.7929 21.7503 15.0931 21.6069 14.4432 21.3283L14.4219 21.3168C13.3184 20.8423 12.4113 20.0032 11.8523 18.94C11.2933 17.8767 11.1164 16.6538 11.3511 15.4757C11.5858 14.2976 12.218 13.2359 13.1417 12.4681C14.0655 11.7002 15.2249 11.2729 16.426 11.2575L16.4542 11.2546C16.47 11.2546 16.4843 11.25 16.4993 11.25C17.8916 11.25 19.227 11.8031 20.2116 12.7877C21.1961 13.7723 21.7493 15.1076 21.7493 16.5C21.7493 17.8924 21.1961 19.2277 20.2116 20.2123C19.227 21.1969 17.8916 21.75 16.4993 21.75H16.5Z"/>
                      <path
                        d="M18.75 15.75H17.25V14.25C17.25 14.0511 17.171 13.8603 17.0303 13.7197C16.8897 13.579 16.6989 13.5 16.5 13.5C16.3011 13.5 16.1103 13.579 15.9697 13.7197C15.829 13.8603 15.75 14.0511 15.75 14.25V15.75H14.25C14.0511 15.75 13.8603 15.829 13.7197 15.9697C13.579 16.1103 13.5 16.3011 13.5 16.5C13.5 16.6989 13.579 16.8897 13.7197 17.0303C13.8603 17.171 14.0511 17.25 14.25 17.25H15.75V18.75C15.75 18.9489 15.829 19.1397 15.9697 19.2803C16.1103 19.421 16.3011 19.5 16.5 19.5C16.6989 19.5 16.8897 19.421 17.0303 19.2803C17.171 19.1397 17.25 18.9489 17.25 18.75V17.25H18.75C18.9489 17.25 19.1397 17.171 19.2803 17.0303C19.421 16.8897 19.5 16.6989 19.5 16.5C19.5 16.3011 19.421 16.1103 19.2803 15.9697C19.1397 15.829 18.9489 15.75 18.75 15.75Z"/>
                    </svg>
                  </span>
        </a>
        <button (click)="sendTextMessage()" class="btn btn-outline app-btn-black d-flex d-md-block p-4" type="button">
                <span class="d-none d-md-inline">
                  Send
                </span>
          <span class="d-md-none icon icon-lg">
                  <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M19.4469 9.1052L1.44695 0.105196C1.27002 0.0166782 1.07081 -0.0173722 0.874531 0.00735335C0.678247 0.0320789 0.493708 0.114469 0.344262 0.2441C0.194815 0.373731 0.0871772 0.544777 0.0349658 0.735598C-0.0172457 0.926418 -0.011684 1.12844 0.0509472 1.3161L2.94545 9.9997L0.0509472 18.6833C-0.011684 18.871 -0.0172457 19.073 0.0349658 19.2638C0.0871772 19.4546 0.194815 19.6257 0.344262 19.7553C0.493708 19.8849 0.678247 19.9673 0.874531 19.992C1.07081 20.0168 1.27002 19.9827 1.44695 19.8942L19.4469 10.8942C19.6131 10.8112 19.7528 10.6835 19.8505 10.5255C19.9481 10.3675 19.9999 10.1854 19.9999 9.9997C19.9999 9.81396 19.9481 9.63189 19.8505 9.4739C19.7528 9.3159 19.6131 9.18824 19.4469 9.1052ZM2.71155 17.0261L4.72045 10.9997H9.99965C10.2649 10.9997 10.5192 10.8943 10.7068 10.7068C10.8943 10.5193 10.9996 10.2649 10.9996 9.9997C10.9996 9.73448 10.8943 9.48013 10.7068 9.29259C10.5192 9.10505 10.2649 8.9997 9.99965 8.9997H4.72045L2.71155 2.9733L16.7638 9.9997L2.71155 17.0261Z"
                      fill="#FFEB3A"/>
                  </svg>
                </span>
        </button>
      </div>
    </form>
    <!-- Chat: Form -->
  </div>
  <!-- Chat: Footer -->
  <input (change)="sendFileMessage($event)" [formControl]="fileControl" accept="image/*" class="d-none"
         id="shareFile"
         type="file">
</div>
